module.exports = __webpack_public_path__ + "img/icon-arrow.53ef8ed8.svg";